import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M17.25 10h-.5V7.75C16.75 5.13 14.62 3 12 3S7.25 5.13 7.25 7.75V10h-.5C5.79 10 5 10.79 5 11.75v7.5c0 .96.79 1.75 1.75 1.75h10.5c.96 0 1.75-.79 1.75-1.75v-7.5c0-.96-.79-1.75-1.75-1.75zm-8.5-2.25c0-1.79 1.46-3.25 3.25-3.25s3.25 1.46 3.25 3.25V10h-6.5V7.75zm8.75 11.5c0 .14-.11.25-.25.25H6.75c-.14 0-.25-.11-.25-.25v-7.5c0-.14.11-.25.25-.25h10.5c.14 0 .25.11.25.25v7.5z"
      fill="currentColor"
    />
    <path
      d="M13.41 13.09c-.78-.79-2.04-.79-2.82 0a1.96 1.96 0 0 0-.18 2.6l-.4 2.22c-.03.15.01.3.11.41.09.11.23.18.38.18h3c.15 0 .29-.07.38-.18.1-.11.14-.26.11-.41l-.4-2.22c.6-.78.54-1.89-.18-2.6zm-.51 4.41h-1.8l.38-2.11-.19-.18c-.39-.39-.39-1.03 0-1.42.39-.39 1.03-.39 1.42 0 .39.39.39 1.03 0 1.42l-.19.18.38 2.11z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Lock');

export default Icon;
